import React from 'react';
import classes from "./staff.module.css";
import Title from '../../containers/title/title';
import StaffMember from '../../containers/staffMember/staffMember';

const Staff = (props) => {
    return (
        <div className={classes.Container}>
            <Title title={props.title} camp={props.camp} />
            <div className={classes.Staff}>{props.staffData?.map((staff) =>
                <StaffMember {...staff} key={staff.id}  camp={props.camp}/>
            )}</div>
        </div>
    )
}
export default Staff;